import React, { useEffect, useContext } from "react";
import "../../Styles/Service.css"; // Import the CSS file
import LazyLoad from "react-lazyload";
import boostIcon from "../../images/boosticon2.png";
// import rikab from "../../images/rikab.png";
import earnIcon from "../../images/EarnIcon.png";
import settingIcon from "../../images/settingIcon.png";
import { AppContext } from "../../Context/Provider";

const Test = () => {
  const { FetchHomeLearnMore, HomeLearnMoreData } = useContext(AppContext);

  useEffect(() => {
    FetchHomeLearnMore();
  }, []);

  return (
    <section className="py-10 learn-about-us-section">
      <div className="container mx-auto flex flex-col md:flex-row items-center justify-between px-6">
        <div className="md:w-1/3 flex flex-col justify-center h-full mt-20">
          <div className="my-4 flex items-start md:my-6">
            <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-gray-200 mr-4">
              <LazyLoad offset={100}>
                <img
                  src={boostIcon}
                  alt="Variety of Cuisines"
                  className="w-8 h-8"
                />
              </LazyLoad>
            </div>
            <div>
              <h4 className="font-bold text-xl md:text-2xl">
                Variety of Cuisines
              </h4>
              <p className="text-gray-700 text-base md:text-lg">
                Explore a diverse selection of local restaurants and
                international cuisines, all available for delivery.
              </p>
            </div>
          </div>

          <div className="my-4 flex items-start md:my-6">
            <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-gray-200 mr-4">
              <LazyLoad offset={100}>
                <img src={earnIcon} alt="Easy Ordering" className="w-8 h-8" />
              </LazyLoad>
            </div>
            <div>
              <h4 className="font-bold text-xl md:text-2xl">Easy Ordering</h4>
              <p className="text-gray-700 text-base md:text-lg">
                Browse menus, customize your orders, and track your delivery
                with just a few clicks on our app.
              </p>
            </div>
          </div>

          <div className="my-4 flex items-start md:my-6">
            <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-gray-200 mr-4">
              <LazyLoad offset={100}>
                <img
                  src={settingIcon}
                  alt="Wide Selection"
                  className="w-8 h-8"
                />
              </LazyLoad>
            </div>
            <div>
              <h4 className="font-bold text-xl md:text-2xl">Wide Selection</h4>
              <p className="text-gray-700 text-base md:text-lg">
                Access a comprehensive range of products, including fresh
                produce, pantry staples, personal care items, and more.
              </p>
            </div>
          </div>

          <div className="my-4 flex items-start md:my-6">
            <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-gray-200 mr-4">
              <LazyLoad offset={100}>
                <img
                  src={settingIcon}
                  alt="Convenient Shopping"
                  className="w-8 h-8"
                />
              </LazyLoad>
            </div>
            <div>
              <h4 className="font-bold text-xl md:text-2xl">
                Convenient Shopping
              </h4>
              <p className="text-gray-700 text-base md:text-lg">
                Our intuitive platform makes it easy to find and purchase
                everything you need from the comfort of your home.
              </p>
            </div>
          </div>

          <div className="my-4 flex items-start md:my-6">
            <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-gray-200 mr-4">
              <LazyLoad offset={100}>
                <img
                  src={settingIcon}
                  alt="Competitive Prices"
                  className="w-8 h-8"
                />
              </LazyLoad>
            </div>
            <div>
              <h4 className="font-bold text-xl md:text-2xl">
                Competitive Prices
              </h4>
              <p className="text-gray-700 text-base md:text-lg">
                Enjoy great deals and savings on a wide array of products, with
                options to suit every budget.
              </p>
            </div>
          </div>
        </div>

        {/* <div className="md:w-1/2 flex justify-center items-center">
          {HomeLearnMoreData?.map((img) => {
            return (
              <LazyLoad height={180} offset={100} once key={img.fileName}>
                <img src={rikab} alt="Rikaab App Screenshot" width="500" />
              </LazyLoad>
            );
          })}
        </div> */}
      </div>
    </section>
  );
};

export default Test;
